import { logger, getContractDataByItsName, ContractsNames, FactoryAbi, createContract } from 'shared';
import { error, request, success, getMaxGas } from 'shared/api';
import { call, put, select, takeLatest } from 'typed-redux-saga';
import { addBlockSaga } from './addBlock';

import { userModel } from 'entities/user';

import { userActions } from '../reducer';

export function* connectPlug({ type, payload: { web3Provider } }: ReturnType<typeof userActions.connectPlug>) {
  yield* put(request(type));

  const {
    chainType,
    address: userAddress,
  } = yield select(userModel.selectors.getUser);

  const [profileAbi] = getContractDataByItsName(ContractsNames.Profile, chainType);

  try {
    yield window?.ic?.plug.requestConnect();

    yield* put(
      userActions.updateUserState({
          icpAddress: window?.ic?.plug?.principalId,
      })
  );

    yield* call(addBlockSaga, {
      type: userActions.addBlock.type,
      payload: {
        blocksArray: [
          {
            blockType: 'Plug',
            blockPayload: { contents: window?.ic?.plug?.principalId },
            blockDescription: ' ',
          },
        ],
        web3Provider,
        withThrowError: true,
      },
    })

    yield* put(success(type));
  } catch (err) {
    yield* put(error(type, err));
    logger('connectPlug', err);
  }
}

export default function* listener() {
  yield takeLatest(userActions.connectPlug.type, connectPlug);
}
